(function () {
  function init(section) {
    const size   = parseInt(section.dataset.imageSize    || 200, 10);
    const gap    = parseInt(section.dataset.gap          || 12,  10);
    const speed  = parseInt(section.dataset.speed        || 30,  10);
    const radius = parseInt(section.dataset.borderRadius || 4,   10);
    const pause  = section.dataset.pauseOnHover === 'true';

    section.style.setProperty('--mq-size',   size   + 'px');
    section.style.setProperty('--mq-gap',    gap    + 'px');
    section.style.setProperty('--mq-speed',  speed  + 's');
    section.style.setProperty('--mq-radius', radius + 'px');

    if (pause) {
      section.querySelectorAll('.marquee-gallery__track').forEach(function (track) {
        track.addEventListener('mouseenter', function () {
          track.classList.add('marquee-gallery__track--paused');
        });
        track.addEventListener('mouseleave', function () {
          track.classList.remove('marquee-gallery__track--paused');
        });
      });
    }
  }

  document.querySelectorAll('[id^="marquee-gallery-"]').forEach(init);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[id^="marquee-gallery-"]');
      if (s) init(s);
    });
  }
})();